 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"index": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"app-page-ForgotPassword-vue":"app-page-ForgotPassword-vue","app-page-PrivacyPolicy-vue":"app-page-PrivacyPolicy-vue","app-page-Register-vue":"app-page-Register-vue","app-page-ResetPassword-vue":"app-page-ResetPassword-vue","app-page-[request]":"app-page-[request]","app-view-BookingSuccessful-vue":"app-view-BookingSuccessful-vue","app-view-Charter-vue~app-view-Dashboard-vue~app-view-NewDashboard-vue~app-view-account-Profile-vue":"app-view-Charter-vue~app-view-Dashboard-vue~app-view-NewDashboard-vue~app-view-account-Profile-vue","app-view-Charter-vue":"app-view-Charter-vue","app-view-Dashboard-vue~app-view-NewDashboard-vue":"app-view-Dashboard-vue~app-view-NewDashboard-vue","app-view-Dashboard-vue":"app-view-Dashboard-vue","app-view-NewDashboard-vue":"app-view-NewDashboard-vue","app-view-account-Profile-vue":"app-view-account-Profile-vue","app-view-CharterRequestSuccessful-vue":"app-view-CharterRequestSuccessful-vue","app-view-Index-vue":"app-view-Index-vue","app-view-MyBookings-vue":"app-view-MyBookings-vue","app-view-Notifications-vue":"app-view-Notifications-vue","app-view-VerifcationSuccessful-vue":"app-view-VerifcationSuccessful-vue","app-view-ViewBooking-vue":"app-view-ViewBooking-vue","app-view-Wallet-vue":"app-view-Wallet-vue","app-view-account-Index-vue":"app-view-account-Index-vue","app-view-account-Password-vue":"app-view-account-Password-vue","app-view-account-PromoCodes-vue":"app-view-account-PromoCodes-vue","app-view-account-SuggestRoute-vue":"app-view-account-SuggestRoute-vue","app-view-account-Support-vue":"app-view-account-Support-vue","app-view-account-TripMenu-vue":"app-view-account-TripMenu-vue"}[chunkId]||chunkId) + "." + {"app-page-ForgotPassword-vue":"150ddc97","app-page-PrivacyPolicy-vue":"1d84ebb9","app-page-Register-vue":"aa0527be","app-page-ResetPassword-vue":"ac23d98d","app-page-[request]":"6b437270","app-view-BookingSuccessful-vue":"1c67db8d","app-view-Charter-vue~app-view-Dashboard-vue~app-view-NewDashboard-vue~app-view-account-Profile-vue":"eac58d6c","app-view-Charter-vue":"2002a8a7","app-view-Dashboard-vue~app-view-NewDashboard-vue":"ddcb2452","app-view-Dashboard-vue":"6e2282e3","app-view-NewDashboard-vue":"707b46d8","app-view-account-Profile-vue":"662f0f6e","app-view-CharterRequestSuccessful-vue":"7454ffc0","app-view-Index-vue":"ec6a6342","app-view-MyBookings-vue":"56f5bc8a","app-view-Notifications-vue":"5d9c0269","app-view-VerifcationSuccessful-vue":"330bf115","app-view-ViewBooking-vue":"36ba9c84","app-view-Wallet-vue":"7e4a223c","app-view-account-Index-vue":"61c36216","app-view-account-Password-vue":"cce823ef","app-view-account-PromoCodes-vue":"eff840fe","app-view-account-SuggestRoute-vue":"bda4babe","app-view-account-Support-vue":"809f50da","app-view-account-TripMenu-vue":"eba71544"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"app-page-PrivacyPolicy-vue":1,"app-page-Register-vue":1,"app-view-BookingSuccessful-vue":1,"app-view-Charter-vue":1,"app-view-Dashboard-vue~app-view-NewDashboard-vue":1,"app-view-Dashboard-vue":1,"app-view-NewDashboard-vue":1,"app-view-Index-vue":1,"app-view-MyBookings-vue":1,"app-view-Notifications-vue":1,"app-view-ViewBooking-vue":1,"app-view-account-PromoCodes-vue":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"app-page-ForgotPassword-vue":"app-page-ForgotPassword-vue","app-page-PrivacyPolicy-vue":"app-page-PrivacyPolicy-vue","app-page-Register-vue":"app-page-Register-vue","app-page-ResetPassword-vue":"app-page-ResetPassword-vue","app-page-[request]":"app-page-[request]","app-view-BookingSuccessful-vue":"app-view-BookingSuccessful-vue","app-view-Charter-vue~app-view-Dashboard-vue~app-view-NewDashboard-vue~app-view-account-Profile-vue":"app-view-Charter-vue~app-view-Dashboard-vue~app-view-NewDashboard-vue~app-view-account-Profile-vue","app-view-Charter-vue":"app-view-Charter-vue","app-view-Dashboard-vue~app-view-NewDashboard-vue":"app-view-Dashboard-vue~app-view-NewDashboard-vue","app-view-Dashboard-vue":"app-view-Dashboard-vue","app-view-NewDashboard-vue":"app-view-NewDashboard-vue","app-view-account-Profile-vue":"app-view-account-Profile-vue","app-view-CharterRequestSuccessful-vue":"app-view-CharterRequestSuccessful-vue","app-view-Index-vue":"app-view-Index-vue","app-view-MyBookings-vue":"app-view-MyBookings-vue","app-view-Notifications-vue":"app-view-Notifications-vue","app-view-VerifcationSuccessful-vue":"app-view-VerifcationSuccessful-vue","app-view-ViewBooking-vue":"app-view-ViewBooking-vue","app-view-Wallet-vue":"app-view-Wallet-vue","app-view-account-Index-vue":"app-view-account-Index-vue","app-view-account-Password-vue":"app-view-account-Password-vue","app-view-account-PromoCodes-vue":"app-view-account-PromoCodes-vue","app-view-account-SuggestRoute-vue":"app-view-account-SuggestRoute-vue","app-view-account-Support-vue":"app-view-account-Support-vue","app-view-account-TripMenu-vue":"app-view-account-TripMenu-vue"}[chunkId]||chunkId) + "." + {"app-page-ForgotPassword-vue":"31d6cfe0","app-page-PrivacyPolicy-vue":"c941500d","app-page-Register-vue":"adeee5a5","app-page-ResetPassword-vue":"31d6cfe0","app-page-[request]":"31d6cfe0","app-view-BookingSuccessful-vue":"bae2902f","app-view-Charter-vue~app-view-Dashboard-vue~app-view-NewDashboard-vue~app-view-account-Profile-vue":"31d6cfe0","app-view-Charter-vue":"7f91aa90","app-view-Dashboard-vue~app-view-NewDashboard-vue":"3de817ff","app-view-Dashboard-vue":"41b9d038","app-view-NewDashboard-vue":"159c874a","app-view-account-Profile-vue":"31d6cfe0","app-view-CharterRequestSuccessful-vue":"31d6cfe0","app-view-Index-vue":"ef728a8e","app-view-MyBookings-vue":"ef728a8e","app-view-Notifications-vue":"40050bdd","app-view-VerifcationSuccessful-vue":"31d6cfe0","app-view-ViewBooking-vue":"ab8b5b29","app-view-Wallet-vue":"31d6cfe0","app-view-account-Index-vue":"31d6cfe0","app-view-account-Password-vue":"31d6cfe0","app-view-account-PromoCodes-vue":"b4f67638","app-view-account-SuggestRoute-vue":"31d6cfe0","app-view-account-Support-vue":"31d6cfe0","app-view-account-TripMenu-vue":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors","chunk-common"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
